const CONFIG = {
  ENV: import.meta.env.NODE_ENV,
  ENV_NAME: import.meta.env.VITE_APP_ENV_NAME,
  STRIPE_PUBLIC_KEY: import.meta.env.VITE_APP_STRIPE_PUBLIC_KEY,
  SCHEDULER_LICENSE_KEY: import.meta.env.VITE_APP_SCHEDULER_LICENSE_KEY,
  RETAIL_SERVICES: import.meta.env.VITE_APP_RETAIL_SERVICES,
  API: import.meta.env.VITE_APP_API_URL,
  GRAPHQL_API: `${import.meta.env.VITE_APP_API_URL}/graphql/`,
  MAINTENANCE_API: `${import.meta.env.VITE_APP_API_URL}/maintenance/`,
  REST_API: `${import.meta.env.VITE_APP_API_URL}/restapi/`,
  TERMINAL_API: `${import.meta.env.VITE_APP_API_URL}/restapi/`,
  FILE_UPLOAD_LIMIT: parseInt(import.meta.env.VITE_APP_DOCUMENT_UPLOAD_LIMIT),
  FEATURE_FLAG_AVA_TAX: import.meta.env.VITE_APP_FEATURE_FLAG_AVA_TAX,
  INTEGRATIONS_API_URL: import.meta.env.VITE_APP_INTEGRATIONS_API_URL,
  FORMS_API_URL: import.meta.env.VITE_APP_RESTORE_FORMS_API_URL,
  USERS_API_URL: import.meta.env.VITE_APP_RESTORE_USERS_API_URL,
  MEDICAL_API_URL: import.meta.env.VITE_APP_RESTORE_MEDICAL_API_URL,
  DATA_REFRESH_INTERVAL: parseInt(
    import.meta.env.VITE_APP_DATA_REFRESH_INTERVAL
  ),
  FEATURE_FLAG_APPOINTMENT_DATA_UPDATE: JSON.parse(
    import.meta.env.VITE_APP_FEATURE_FLAG_APPOINTMENT_DATA_UPDATE || 'true'
  ),
  BOOKING_API_URL: import.meta.env.VITE_APP_RESTORE_BOOKING_API_URL,
  FINANCE_API_URL: import.meta.env.VITE_APP_RESTORE_FINANCE_API_URL,
  DOCUMENTS_API_URL: import.meta.env.VITE_APP_RESTORE_DOCUMENTS_API_URL,
  APPT_TEST_HARNESS: import.meta.env?.VITE_APP_APT_TEST_HARNESS || false,
  SENTRY_DSN: import.meta.env?.REACT_APP_SENTRY_DSN,
  CHATBOT_URL: import.meta.env?.REACT_APP_RESTORE_CHATBOT_URL,
  TABLEAU_REPORT_LINK: import.meta.env?.VITE_APP_TABLEAU_REPORT_LINK
};

export default CONFIG;
